import { HttpService } from '@src/api/common/HttpService';
import { CTE_API_URL } from '@src/constants/BaseUrls';
import { MenuRequest, MenuResponse } from './MenuTypes';

const MenuService = () => {
  const { HttpGet } = HttpService();

  const GetMenu = async (
    request: MenuRequest = { skipRoles: false }
  ): Promise<MenuResponse> => {
    // Build query parameters
    const queryParams = new URLSearchParams();

    if (request.search) {
      queryParams.append('search', request.search);
    }

    if (request.skipRoles !== undefined) {
      queryParams.append('skipRoles', request.skipRoles.toString());
    }

    const query = queryParams.toString();
    const url = `${CTE_API_URL}/api/v1/menu${query ? `?${query}` : ''}`;

    const apiResponse = await HttpGet(url);

    // Transform ApiResponse to MenuResponse
    if (apiResponse.status === 200 && apiResponse.data) {
      return apiResponse.data as MenuResponse;
    } else {
      // Return error response in MenuResponse format
      return {
        results: [],
        message: apiResponse.message || 'Failed to fetch menu',
        hasError: true,
        hasWarning: false,
        queryElapsedTime: 0,
      };
    }
  };

  return { GetMenu };
};

export { MenuService };
